import React from 'react'

import { BrandedAlertModal } from 'components/Modal';

interface ResumePurchaseFailProps {
    isOpen: boolean
    onConfirm: () => void
    onCancel: () => void
}

const TokenIcon: React.FC = () => (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false">
        <circle cx="12" cy="12" r="8.5" stroke="currentColor" strokeWidth="1.6" />
        <path d="M12 7.5v9M9.5 10a2.5 2 0 0 1 2.5-2c1.4 0 2.5.9 2.5 2s-1.1 2-2.5 2-2.5.9-2.5 2 1.1 2 2.5 2a2.5 2 0 0 0 2.5-2" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" />
    </svg>
);

const ResumePurchaseFail = ({
    isOpen,
    onConfirm,
    onCancel,
}: ResumePurchaseFailProps) => {
    return (
        <BrandedAlertModal
            isOpen={isOpen}
            onClose={onCancel}
            headerLabel="Tokens"
            headerIcon={<TokenIcon />}
            illustration={<TokenIcon />}
            illustrationVariant="danger"
            title="Oopss..."
            ariaLabel="Not enough tokens"
            actions={[
                { label: 'Cancel', onClick: onCancel, variant: 'secondary' },
                { label: 'Buy tokens', onClick: onConfirm, variant: 'primary' },
            ]}
        >
            Seems like you don't have enough tokens.
        </BrandedAlertModal>
    )
}

export default ResumePurchaseFail;
